import { render, staticRenderFns } from "./ExamItem.vue?vue&type=template&id=76738370&"
import script from "./ExamItem.vue?vue&type=script&lang=js&"
export * from "./ExamItem.vue?vue&type=script&lang=js&"
import style0 from "./ExamItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports